import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ArticleState, articleAdapter } from '../reducers/article.reducer';

export const getArticleState = createFeatureSelector<ArticleState>('articles');
export const getIds = (state: ArticleState) => state.ids;

export const {
  selectIds: getArticleIds,
  selectEntities: getArticleEntities,
  selectAll: getAllArticles,
  selectTotal: getTotalArticles,
} = articleAdapter.getSelectors(getArticleState);

export const getArticleById = (articleId: string) =>
  createSelector(getAllArticles, (allItems) => {
    if (allItems) {
      return allItems.find((item) => {
        return item.id === articleId;
      });
    } else {
      return null;
    }
  });
